export const SEARCH_PARAMS = {
  FUNDER_NAME: "funderName",
  ENTITY_NAME: "entityName",
  ENTITY_ID: "entityId",
  SHORT_NAME: "shortName",
  TOTAL_PUBLICATIONS: "totalPublications",
  PERCENT_INCREASE: "percentIncrease",
  // SEARCH: "search",
  ENTITY_CONTENT_SEARCH: "entityContentSearch",
  ENTITY_DETAILS_SEARCH: "entityDetailsSearch",
  SEARCH_TYPE: "searchType",
  SEARCH_VALUE: "searchValue",
  SORT_KEY: "sortKey",
  SORT_ORDER: "sortOrder",
  CURRENT_PAGE: "page",
  PAGE_SIZE: "pageSize",
  TAB: "tab",
  ACTIVE_METRICS_CARD: "activeMetricsCard",
  FILTER_BY: "filterBy",
  FILTER_BY_NAME:"filterByName",
  MEMBER_ID: "memberId",
  PUBLICATION_FILTER: "publicationFilter",
  PUBLICATION_TIME_FILTER: "publicationTimeFilter",
  NUMBER_OF_PUBLISHER: "publishersNum",
  EXPAND_ID: "expandId",
  DOI: "doi",
  VISIBLE_FIELDS: "visibleFields",
  //   YEAR: "year",
  //   OPEN_ACCESS: "openAccess",
};
